import React from 'react';
import { useNavigate } from 'react-router-dom';
import banner from '../Images/banner-removebg-preview.png';
import ranaphoto from '../Images/round-gradient-designify.png'
import Particles from "react-tsparticles";
import { loadFull } from "tsparticles";

const Banner = () => {
    const navigate = useNavigate();

    const particlesInit = async (main) => {
        console.log(main);

        // you can initialize the tsParticles instance (main) here, adding custom shapes or presets
        // this loads the tsparticles package bundle, it's the easiest method for getting everything ready
        // starting from v2 you can add only the features you need reducing the bundle size
        await loadFull(main);
    };

    const particlesLoaded = (container) => {
        console.log(container);
    };
    return (

        <>
            <Particles
                id="tsparticles"
                init={particlesInit}
                loaded={particlesLoaded}
                options={{
                    // background: {
                    //     color: {
                    //         value: "#FFFFFF",
                    //     },
                    // },
                    fpsLimit: 600,
                    interactivity: {
                        events: {
                            onClick: {
                                enable: true,
                                mode: "push",
                            },
                            onHover: {
                                enable: true,
                                mode: "repulse",
                            },
                            resize: true,
                        },
                        modes: {
                            push: {
                                quantity: 4,
                            },
                            bubble: {
                                distance: 400,
                                duration: 2,
                                opacity: 0.8,
                                size: 40,
                            },
                            repulse: {
                                distance: 40,
                                duration: 0.4,
                            },
                        },
                    },
                    particles: {
                        color: {
                            value: "#ff0000",
                        },
                        links: {
                            color: "#90f5af",
                            distance: 120,
                            enable: true,
                            opacity: 0.4,
                            width: 1,
                        },
                        collisions: {
                            enable: true,
                        },
                        move: {
                            direction: "none",
                            enable: true,
                            outModes: {
                                default: "bounce",
                            },
                            random: false,
                            speed: 3,
                            straight: false,
                        },
                        number: {
                            density: {
                                enable: true,
                                area: 800,
                            },
                            value: 100,
                        },
                        opacity: {
                            value: 0.3,
                        },
                        shape: {
                            type: "circle",
                        },
                        size: {
                            value: { min: 1, max: 5 },
                        },
                    },
                    detectRetina: true,
                }}
            />
            <div class="hero min-h-screen bg-base-100">
                <div class="hero-content flex-col lg:flex-row-reverse">
                    <div className='flex-1 '>
                        <img src={banner} class="max-w-sm rounded-lg transform transition-all hover:scale-110" alt=''/>
                    </div>

                    <div className='flex-1 h-full'>
                        <h1 class="text-3xl font-bold"><span className='text-orange-400'>Hello!</span> I am</h1>
                        <h2 class="text-5xl font-bold mt-2"><span className='text-green-600'>Tauhidur</span> Rahman Rana</h2>
                        <h1 className='text-3xl font-bold py-6 text-orange-300'>Frontend Developer</h1>
                        <button class="btn">Contact Me</button>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Banner;